export type CoachPostMeetingSource = "reviews" | "meetings" | "leaders";

export function buildCoachPostMeetingRoute(
  transcriptId: string,
  options?: {
    from?: CoachPostMeetingSource;
    leaderId?: string | null;
    evidence?: CoachHealthEvidenceRouteIdentity;
  },
): string {
  if (options?.evidence) {
    return buildCoachHealthEvidenceRoute(
      `/coach/post-meeting/${transcriptId}`,
      options.evidence,
    );
  }
  const params = new URLSearchParams();
  if (options?.from) {
    params.set("from", options.from);
  }
  if (options?.leaderId) {
    params.set("leaderId", options.leaderId);
  }

  const query = params.toString();
  return query.length > 0
    ? `/coach/post-meeting/${transcriptId}?${query}`
    : `/coach/post-meeting/${transcriptId}`;
}
import {
  buildCoachHealthEvidenceRoute,
  type CoachHealthEvidenceRouteIdentity,
} from "@/lib/coachHealth/coachHealthEvidenceRoute";
